import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { APP_VERSION } from '../version';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'https://dare.exlva.com';

// Default footer settings (matches backend defaults)
const DEFAULT_SETTINGS = {
  copyright_text: '© {year} BioQuest Solutions. All rights reserved.',
  powered_by_text: 'Powered by BioQuest Solutions',
  powered_by_url: 'https://www.bioquestglobal.com',
  is_visible: true,
  background_color: '#111827',
  text_color: '#9CA3AF',
  link_color: '#60A5FA',
  font_size: 'small'
};

const VersionFooter = ({ className = '' }) => {
  const [settings, setSettings] = useState({ ...DEFAULT_SETTINGS });

  useEffect(() => {
    fetchFooterSettings();
  }, []);

  const fetchFooterSettings = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/admin/footer-settings`);
      if (response.data) {
        // Merge with defaults to ensure all fields are present
        setSettings({
          ...DEFAULT_SETTINGS,
          ...response.data
        });
      }
    } catch (error) {
      // Use default settings on error
      console.log('Using default footer settings');
    }
  };

  // Don't render if footer is hidden
  if (!settings.is_visible) {
    return null;
  }

  // Replace {year} placeholder with current year
  const currentYear = new Date().getFullYear();
  const copyrightText = (settings.copyright_text || '').replace('{year}', currentYear);

  // Get font size class based on setting
  const getFontSizeClass = (size) => {
    switch (size) {
      case 'small': return 'text-xs';
      case 'medium': return 'text-sm';
      case 'large': return 'text-base';
      default: return 'text-xs';
    }
  };

  return (
    <footer 
      className={`fixed bottom-0 left-0 right-0 py-2 px-4 z-40 ${getFontSizeClass(settings.font_size)} ${className}`}
      style={{ backgroundColor: settings.background_color }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4">
          {/* Copyright */}
          <span style={{ color: settings.text_color }}>
            {copyrightText}
          </span>
          
          <span style={{ color: settings.text_color }} className="hidden sm:inline">|</span>
          
          {/* Powered by link */}
          <a 
            href={settings.powered_by_url} 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:opacity-80 transition-opacity"
            style={{ color: settings.link_color }}
          >
            {settings.powered_by_text}
          </a>
          
          <span style={{ color: settings.text_color }} className="hidden sm:inline">|</span>
          
          {/* Release Version - single source of truth */}
          <span style={{ color: settings.text_color }}>
            Release <span style={{ color: settings.link_color }} className="font-medium">{APP_VERSION}</span>
          </span>
        </div>
      </div>
    </footer>
  );
};

// Export version info for use elsewhere
export const getVersionInfo = () => ({
  version: APP_VERSION
});

export default VersionFooter;
